export async function layerRefresh(lyr) {
  lyr.refresh();
}
